import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import { useClassNames } from '../utils';
import PredefinedRanges from './PredefinedRanges';
import Stack from '../Stack';

var SubmitButton = function SubmitButton(_ref) {
  var hide = _ref.hide,
      disabledOkBtn = _ref.disabledOkBtn,
      calendarDate = _ref.calendarDate,
      onOk = _ref.onOk,
      children = _ref.children;

  if (hide) {
    return null;
  }

  var disabled = disabledOkBtn === null || disabledOkBtn === void 0 ? void 0 : disabledOkBtn(calendarDate);
  return /*#__PURE__*/React.createElement(Button, {
    appearance: "primary",
    size: "sm",
    disabled: disabled,
    onClick: disabled ? undefined : onOk
  }, children);
};
/**
 * Toolbar for DatePicker and DateRangePicker
 */


var Toolbar = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'picker-toolbar' : _props$classPrefix,
      disabledOkBtn = props.disabledOkBtn,
      disabledShortcut = props.disabledShortcut,
      hideOkBtn = props.hideOkBtn,
      onOk = props.onOk,
      onClickShortcut = props.onClickShortcut,
      calendarDate = props.calendarDate,
      ranges = props.ranges,
      locale = props.locale,
      rest = _objectWithoutPropertiesLoose(props, ["className", "classPrefix", "disabledOkBtn", "disabledShortcut", "hideOkBtn", "onOk", "onClickShortcut", "calendarDate", "ranges", "locale"]);

  var _useClassNames = useClassNames(classPrefix),
      merge = _useClassNames.merge,
      prefix = _useClassNames.prefix,
      withClassPrefix = _useClassNames.withClassPrefix;

  if (hideOkBtn && (ranges === null || ranges === void 0 ? void 0 : ranges.length) === 0) {
    return null;
  }

  var classes = merge(className, withClassPrefix());
  return /*#__PURE__*/React.createElement(Stack, _extends({
    ref: ref,
    className: classes,
    justifyContent: "space-between",
    alignItems: "flex-start"
  }, rest), /*#__PURE__*/React.createElement(PredefinedRanges, {
    className: prefix('ranges'),
    ranges: ranges,
    calendarDate: calendarDate,
    locale: locale,
    disabledShortcut: disabledShortcut,
    onClickShortcut: onClickShortcut
  }), /*#__PURE__*/React.createElement("div", {
    className: prefix('right')
  }, /*#__PURE__*/React.createElement(SubmitButton, {
    disabledOkBtn: disabledOkBtn,
    hide: hideOkBtn,
    calendarDate: calendarDate,
    onOk: onOk
  }, locale === null || locale === void 0 ? void 0 : locale.ok)));
});
Toolbar.displayName = 'Toolbar';
Toolbar.propTypes = {
  ranges: PropTypes.array,
  className: PropTypes.string,
  classPrefix: PropTypes.string,
  calendarDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.arrayOf(PropTypes.instanceOf(Date))]).isRequired,
  onClickShortcut: PropTypes.func,
  onOk: PropTypes.func,
  disabledShortcut: PropTypes.func,
  disabledOkBtn: PropTypes.func,
  hideOkBtn: PropTypes.bool
};
export default Toolbar;